// import { $translate } from '@/utils/i18n';
export const tableConfig = {
    searchList: {
        searchRightSpan: 5,
        isSearchFlag: true,
        searchTxt: [
            {
                type: 'input',
                value: 'barcodeNoSplit',
                span: 6,
                name: '条码字符串',
                clearable: true
            },
            {
                type: 'input',
                value: 'sourceBillNoSplit',
                span: 6,
                clearable: true,
                name: '单据编码'
            },
            {
                type: 'input',
                value: 'itemCode',
                span: 6,
                clearable: true,
                name: '产品编码'
            }, {
                type: 'select',
                value: 'billTypeClassList',
                span: 6,
                clearable: true,
                multiple: true,
                options: [],
                name: '单据类型'
            }, {
                type: 'select',
                value: 'inOutType',
                span: 6,
                clearable: true,
                options: [
                    { label: '出库', value: 'OUT' },
                    { label: '入库', value: 'IN' }
                ],
                name: '出入库类型',
                isClose: true
            }, {
                type: 'select',
                value: 'scanSystemList',
                span: 6,
                clearable: true,
                multiple: true,
                dicOptionsKey: 'SCAN_SYSTEM',
                options: [],
                name: '扫码系统',
                isClose: true
            }, {
                type: 'select',
                value: 'recSourceSysList',
                span: 6,
                clearable: true,
                multiple: true,
                dicOptionsKey: 'ORDER_SYSTEM',
                options: [],
                name: '订单系统',
                isClose: true
            },
            {
                type: 'input',
                value: 'recTenantCode',
                span: 6,
                clearable: true,
                name: '收货租户编码',
                isClose: true
            },
            {
                type: 'input',
                value: 'shipTenantCode',
                span: 6,
                clearable: true,
                name: '发货租户编码',
                isClose: true
            },
            {
                type: 'select',
                value: 'recOrgTypeList',
                span: 6,
                clearable: true,
                multiple: true,
                dicOptionsKey: 'SN_LBCS_SHIP_ORG_TYPE',
                options: [],
                name: '收货单位类型',
                isClose: true
            },
            {
                type: 'select',
                value: 'shipOrgTypeList',
                span: 6,
                clearable: true,
                multiple: true,
                dicOptionsKey: 'SN_LBCS_SHIP_ORG_TYPE',
                options: [],
                name: '发货单位类型',
                isClose: true
            },
            {
                type: 'input',
                value: 'customerCode',
                span: 6,
                clearable: true,
                name: '直发客户编码',
                isClose: true
            },
            {
                type: 'datePicker',
                value: 'billDate',
                span: 6,
                clearable: true,
                name: '单据时间',
                isClose: true
            },
            {
                type: 'datePicker',
                value: 'creationDate',
                span: 6,
                clearable: true,
                name: '创建时间',
                isClose: true
            },
            {
                type: 'datePicker',
                value: 'prodDate',
                span: 6,
                clearable: true,
                name: '生产日期',
                isClose: true
            },
            {
                type: 'datePicker',
                value: 'opDate',
                span: 6,
                clearable: true,
                name: '扫码日期',
                isClose: true
            },
            {
                type: 'category',
                value: 'checkBox', // TODO更改名字
                span: 24,
                isClose: true
            }
        ]
    },
    table: {
        highlight: true,
        selectBtn: false,
        sequence: true,
        leftOperation: true,
        expand: true,
        expandNumber: 6,
        showOtpColumnConfig: true,
        rowKey: 'swapId',
        height: 'calc( 100vh - 300px )',
        columns: [
            {
                // label: $translate('lang.E3202101280001', {
                //     defaultText: '条码字符串'
                // }),
                label: '条码字符串',
                align: 'center',
                prop: 'barcodeNo',
                fixed: 'left',
                width: 230,
                type: 'category',
                disabled: true,
                columnStick: true
            },
            {
                // label: $translate('lang.E3202101280037', {
                //     defaultText: '扫码日期'
                // }),
                label: '扫码日期',
                align: 'center',
                prop: 'opDate',
                sort: true,
                fixed: 'left',
                width: 170,
                disabled: true,
                columnStick: true
            },
            {
                // label: $translate('lang.E3202101280038', {
                //     defaultText: '单据编码'
                // }),
                label: '单据编码',
                align: 'center',
                prop: 'sourceBillNo',
                width: 260
            }, {
                // label: $translate('lang.E3202101280038', {
                //     defaultText: '单据编码'
                // }),
                label: '创建时间',
                align: 'center',
                prop: 'creationDate',
                width: 260
            },
            {
                // label: $translate('lang.E3202101280038', {
                //     defaultText: '业务类型'
                // }),
                label: '单据类型',
                align: 'center',
                prop: 'billTypeName',
                width: 110
            },
            {
                // label: $translate('lang.E3202101280003', {
                //     defaultText: '产品编码'
                // }),
                label: '产品编码',
                align: 'center',
                prop: 'itemCode',
                width: 160
            },
            {
                // label: $translate('lang.E3202101280013', {
                //     defaultText: '产品描述'
                // }),
                label: '产品描述',
                align: 'center',
                prop: 'itemName',
                width: 160
            },
            {
                // label: $translate('lang.E3202101280032', {
                //     defaultText: '订单来源系统'
                // }),
                label: '订单来源系统',
                align: 'center',
                prop: 'recSourceSys',
                width: 100
            },
            {
                label: '生产日期',
                align: 'center',
                prop: 'prodDate',
                width: 170
            },
            {
                label: '最终节点',
                align: 'center',
                prop: 'isReadTheEnd',
                width: 80
            },
            {
                label: '物流最终节点',
                align: 'center',
                prop: 'isReadTheLogistics',
                width: 120
            },
            {
                label: '出入库类型',
                align: 'center',
                prop: 'inoutType',
                width: 120
            },
            {
                label: '发货单位类型',
                align: 'center',
                prop: 'shipOrgType',
                width: 100
            },
            {
                label: '发货单位编码',
                align: 'center',
                prop: 'shipOrgCode',
                width: 120
            },
            {
                label: '发货单位名称',
                align: 'center',
                prop: 'shipOrgName',
                width: 260
            },
            {
                label: '收货单位类型',
                align: 'center',
                prop: 'recOrgType',
                width: 120
            },
            {
                label: '收货单位编码',
                align: 'center',
                prop: 'recOrgCode',
                width: 120
            },
            {
                label: '收货单位名称',
                align: 'center',
                prop: 'recOrgName',
                width: 260
            },
            {
                label: '直发客户编码',
                align: 'center',
                prop: 'customerCode',
                width: 120
            },
            {
                label: '直发客户名称',
                align: 'center',
                prop: 'customerName',
                width: 260
            },
            {
                label: '中心编码',
                align: 'center',
                prop: 'branchCode',
                width: 120
            },
            {
                label: '中心名称',
                align: 'center',
                prop: 'branchName',
                width: 260
            },
            {
                label: '扫码人',
                align: 'center',
                prop: 'opPerson',
                width: 100
            },
            {
                label: '单据日期',
                align: 'center',
                prop: 'billDate',
                width: 179
            },
            {
                label: '扫码来源',
                prop: 'scanSystem',
                align: 'center',
                width: 100
                // isHidden: true,
                // hiddenColumn: true
            },
            {
                label: '扫码仓库',
                prop: 'whName',
                align: 'center',
                width: 160
                // isHidden: true,
                // hiddenColumn: true
            },
            {
                label: '扫码仓库编码',
                prop: 'whCode',
                align: 'center',
                width: 160
                // isHidden: true,
                // hiddenColumn: true
            },
            {
                label: '任务单号',
                prop: 'taskNo',
                align: 'center',
                width: 230
                // isHidden: true,
                // hiddenColumn: true
            },
            {
                label: '服务平台',
                prop: 'siteName',
                align: 'center',
                width: 160
                // isHidden: true,
                // hiddenColumn: true
            },
            {
                label: '业务模式',
                prop: 'businessMode',
                align: 'center',
                width: 100
                // isHidden: true,
                // hiddenColumn: true
            },
            {
                label: '配送方式',
                prop: 'deliveryTypeName',
                align: 'center',
                width: 100
                // isHidden: true,
                // hiddenColumn: true
            },
            {
                label: '发车单号',
                prop: 'dispatchNo',
                align: 'center',
                width: 230
                // isHidden: true,
                // hiddenColumn: true
            },
            {
                label: '司机',
                prop: 'driver',
                align: 'center',
                width: 100
                // isHidden: true,
                // hiddenColumn: true
            },
            {
                label: '承运商',
                prop: 'carrierName',
                align: 'center',
                width: 160
                // isHidden: true,
                // hiddenColumn: true
            },
            {
                label: '承运商编码',
                prop: 'carrierCode',
                align: 'center',
                width: 160
                // isHidden: true,
                // hiddenColumn: true
            },
            {
                label: '发货地址',
                prop: 'senderDetailAddr',
                align: 'center',
                width: 230
                // isHidden: true,
                // hiddenColumn: true
            },
            {
                label: '收货地址',
                prop: 'receiverDetailAddr',
                align: 'center',
                width: 230
                // isHidden: true,
                // hiddenColumn: true
            },
            {
                label: '网点',
                prop: 'netWorkName',
                align: 'center',
                width: 100
                // isHidden: true,
                // hiddenColumn: true
            },
            {
                label: '外部平台单号',
                prop: 'externalOrderNo',
                align: 'center',
                width: 200
                // isHidden: true,
                // hiddenColumn: true
            },
            {
                label: '外部货主',
                prop: 'upCustomerName',
                align: 'center',
                width: 160
                // isHidden: true,
                // hiddenColumn: true
            },
            {
                label: '运单号',
                prop: 'expressCode',
                align: 'center',
                width: 200
                // isHidden: true,
                // hiddenColumn: true
            },
            {
                label: '发货租户',
                prop: 'shipTenantName',
                align: 'center',
                width: 160
                // isHidden: true,
                // hiddenColumn: true
            },
            {
                label: '发货租户编码',
                prop: 'shipTenantCode',
                align: 'center',
                width: 160
                // isHidden: true,
                // hiddenColumn: true
            },
            {
                label: '收货租户',
                prop: 'recTenantName',
                align: 'center',
                width: 160
                // isHidden: true,
                // hiddenColumn: true
            },
            {
                label: '收货租户编码',
                prop: 'recTenantCode',
                align: 'center',
                width: 160
                // isHidden: true,
                // hiddenColumn: true
            },
            {
                label: '发货仓库',
                prop: 'shipOrgWhName',
                align: 'center',
                width: 160
                // isHidden: true,
                // hiddenColumn: true
            },
            {
                label: '发货仓库编码',
                prop: 'shipOrgWhCode',
                align: 'center',
                width: 160
                // isHidden: true,
                // hiddenColumn: true
            },
            {
                label: '收货仓库',
                prop: 'recOrgWhName',
                align: 'center',
                width: 160
                // isHidden: true,
                // hiddenColumn: true
            },
            {
                label: '收货仓库编码',
                prop: 'recOrgWhCode',
                align: 'center',
                width: 160
                // isHidden: true,
                // hiddenColumn: true
            }
        ],
        action: [
            {
                type: 'text',
                icon: 'el-icon-right',
                event: 'detail'
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageNo: 1,
        pageSizes: [10, 20, 30, 60, 100]
    },
    showPage: true
};
